// contact.js

/* =========================================================
 * Contact Page Script (CF7)
 * 役割ごとに分割して、ページ限定で初期化する
 * ========================================================= */

/* =========================================================
 * 0. 実行条件（対象ページ判定）
 * ========================================================= */
const CONTACT_PAGE_CLASS = "page-cntctv";
const isContactPage = () =>
  document.body.classList.contains(CONTACT_PAGE_CLASS);

/* =========================================================
 * 1. 初期化トリガー（DOMContentLoaded / CF7イベント）
 * ========================================================= */
document.addEventListener("DOMContentLoaded", initContactPage);
document.addEventListener("wpcf7mailsent", initContactPage); // 送信後にDOMが差し替わるケース対策（不要なら削除OK）

function initContactPage() {
  if (!isContactPage()) return;

  setupSelectOptgroups();
  setupPostalInputmode();
  initKanaValidation(); // カナバリデーションも同ページ内で初期化
}

/* =========================================================
 * 2. お問い合わせ内容セレクト：optgroup を疑似生成
 * ========================================================= */
function setupSelectOptgroups() {
  const select = document.querySelector('select[name="your-inquiry"]');
  if (!select) return;

  // 二重初期化防止（初回のみ実行）
  if (select.dataset.optgroupInitialized === "true") return;
  select.dataset.optgroupInitialized = "true";

  // もともとの選択値を退避（※念のため）
  const selectedValueBefore = select.value;

  // optionをクローンして再構築
  const original = Array.from(select.options).map((opt) => opt.cloneNode(true));
  select.innerHTML = "";

  // プレースホルダー
  const placeholder = document.createElement("option");
  placeholder.textContent = "お問い合わせ内容をご選択ください";
  placeholder.value = "";
  placeholder.disabled = true;
  placeholder.selected = true;
  placeholder.hidden = true;
  select.appendChild(placeholder);

  let currentGroup = null;

  original.forEach((opt) => {
    const text = (opt.text || "").trim();

    if (text.startsWith("optgroup-")) {
      currentGroup = document.createElement("optgroup");
      currentGroup.label = text.replace("optgroup-", "");
      select.appendChild(currentGroup);
      return;
    }

    if (text === "endoptgroup") {
      currentGroup = null;
      return;
    }

    if (text !== "") {
      (currentGroup || select).appendChild(opt);
    }
  });

  // 選択値の復元（該当があれば戻す）
  if (selectedValueBefore) {
    const candidate = select.querySelector(
      `option[value="${CSS.escape(selectedValueBefore)}"]`,
    );
    if (candidate && !candidate.disabled) select.value = selectedValueBefore;
  }
}

/* =========================================================
 * 3. 郵便番号：スマホで数字キーボードを出す属性付与
 * ========================================================= */
function setupPostalInputmode() {
  const postalInputs = document.querySelectorAll("input.p-postal-code");
  if (!postalInputs.length) return;

  postalInputs.forEach((input) => {
    input.setAttribute("inputmode", "numeric"); // スマホで数字キーボード
    input.setAttribute("pattern", "[0-9]*"); // 数字だけ受け付けるヒント
    if (!input.hasAttribute("autocomplete")) {
      input.setAttribute("autocomplete", "postal-code");
    }
  });
}

/* =========================================================
 * 4. カナ入力バリデーション（全角カタカナ）
 * ========================================================= */
function initKanaValidation() {
  if (!isContactPage()) return;

  const targetNames = [
    "your-company-kana",
    "your-first-name-kana",
    "your-last-name-kana",
  ];

  const kanaRegex = /^[ァ-ヶー・\s　]+$/u;

  const requiredText = "こちらは入力必須項目です。";
  const kanaText = "全角カタカナで入力してください。";
  const formErrorText = "入力内容に問題があります。確認して再度お試しください。";

  const touched = new Set();
  const state = new Map();

  const isRequiredField = (input) => {
    if (!input) return false;
    if (input.required) return true;
    if (input.getAttribute("aria-required") === "true") return true;
    if (input.classList.contains("wpcf7-validates-as-required")) return true;
    return false;
  };

  const setFormInvalidState = (form, isInvalid) => {
    if (!form) return;

    // CF7に寄せる（テーマ側が見ていることが多い）
    form.setAttribute("data-status", isInvalid ? "invalid" : "init");

    // ここが要望：カナエラー時も invalid を付ける
    if (isInvalid) form.classList.add("invalid");
    else form.classList.remove("invalid");

    // response-output の aria-hidden も整える（テーマが見てる場合がある）
    const out = form.querySelector(".wpcf7-response-output");
    if (out) out.setAttribute("aria-hidden", isInvalid ? "false" : "true");
  };

  const removeCf7DefaultTips = (wrap) => {
    if (!wrap) return;
    wrap
      .querySelectorAll(".wpcf7-not-valid-tip:not(.js-kana-tip)")
      .forEach((el) => el.remove());

    const next = wrap.nextElementSibling;
    if (
      next &&
      next.classList &&
      next.classList.contains("wpcf7-not-valid-tip") &&
      !next.classList.contains("js-kana-tip")
    ) {
      next.remove();
    }
  };

  const getOrCreateTip = (wrap) => {
    let tip = wrap.querySelector(".wpcf7-not-valid-tip.js-kana-tip");
    if (tip) return tip;

    tip = document.createElement("span");
    tip.className = "wpcf7-not-valid-tip js-kana-tip";
    tip.setAttribute("role", "alert");
    tip.style.display = "none";
    tip.setAttribute("aria-hidden", "true");
    wrap.appendChild(tip);
    return tip;
  };

  const isTipVisible = (tip) => {
    if (!tip) return false;
    if (tip.style.display === "none") return false;
    if (tip.getClientRects().length === 0) return false;
    return true;
  };

  const showTip = (input, tip, message) => {
    input.classList.add("wpcf7-not-valid");
    input.setAttribute("aria-invalid", "true");

    tip.textContent = message;
    tip.setAttribute("aria-hidden", "false");
    tip.style.display = "block";
  };

  const hideTip = (input, tip) => {
    input.classList.remove("wpcf7-not-valid");
    input.setAttribute("aria-invalid", "false");

    if (tip) {
      tip.setAttribute("aria-hidden", "true");
      tip.style.display = "none";
      tip.textContent = "";
    }
  };

  const computeInvalid = (input) => {
    const v = input.value.trim();
    const required = isRequiredField(input);

    if (!required && v === "") return false;
    if (v === "") return true;
    return !kanaRegex.test(v);
  };

  const computeMessage = (input) => {
    const v = input.value.trim();
    const required = isRequiredField(input);

    if (required && v === "") return requiredText;
    if (v !== "" && !kanaRegex.test(v)) return kanaText;
    return "";
  };

  const validateOne = (input, force = false) => {
    const wrap = input.closest(".wpcf7-form-control-wrap");
    if (!wrap) return;

    removeCf7DefaultTips(wrap);

    const name = input.name;
    const tip = getOrCreateTip(wrap);

    const canShow = force || touched.has(name);
    if (!canShow) {
      if (isTipVisible(tip) || input.classList.contains("wpcf7-not-valid")) {
        hideTip(input, tip);
      }
      state.set(name, false);
      return;
    }

    const invalid = computeInvalid(input);
    const message = computeMessage(input);

    const prevInvalid = state.get(name);

    const needsReshow =
      invalid &&
      (!input.classList.contains("wpcf7-not-valid") ||
        input.getAttribute("aria-invalid") !== "true" ||
        !isTipVisible(tip));

    const needsRehide =
      !invalid &&
      (input.classList.contains("wpcf7-not-valid") ||
        input.getAttribute("aria-invalid") === "true" ||
        isTipVisible(tip));

    if (prevInvalid === invalid && !needsReshow && !needsRehide) return;

    state.set(name, invalid);

    if (invalid) showTip(input, tip, message);
    else hideTip(input, tip);
  };

  const validateAll = (root = document, force = false) => {
    targetNames.forEach((name) => {
      const input = root.querySelector(`input[name="${name}"]`);
      if (input) validateOne(input, force);
    });
  };

  const bind = (root = document) => {
    targetNames.forEach((name) => {
      const input = root.querySelector(`input[name="${name}"]`);
      if (!input || input.dataset.kanaBound) return;

      input.addEventListener("input", () => {
        touched.add(name);
        validateOne(input, false);

        // 片方を先に入力したら、もう片方が空なら必須を出す（後半→前半のみ）
        if (name === "your-last-name-kana") {
          const first = root.querySelector(`input[name="your-first-name-kana"]`);
          if (first) {
            const v = input.value.trim();
            const fv = first.value.trim();
            if (v !== "" && fv === "" && isRequiredField(first)) {
              touched.add("your-first-name-kana");
              validateOne(first, true);
            }
          }
        }
      });

      input.addEventListener("blur", () => {
        touched.add(name);
        validateOne(input, true);
      });

      input.dataset.kanaBound = "1";
    });
  };

  const bindAfterKanaTrigger = (form) => {
    if (form.dataset.kanaObserverBound) return;
    form.dataset.kanaObserverBound = "1";

    let scheduled = false;
    let lastEvent = null;

    const getLastKanaInput = () => {
      const kanaInputs = targetNames
        .map((n) => form.querySelector(`input[name="${n}"]`))
        .filter(Boolean);
      if (!kanaInputs.length) return null;

      return kanaInputs.reduce((acc, cur) => {
        if (!acc) return cur;
        const pos = acc.compareDocumentPosition(cur);
        return pos & Node.DOCUMENT_POSITION_FOLLOWING ? cur : acc;
      }, null);
    };

    const isAfterKanaFields = (e) => {
      const t = e && e.target;
      if (!t || !(t instanceof Element)) return false;

      const lastKana = getLastKanaInput();
      if (!lastKana) return false;

      const tWrap = t.closest && t.closest(".wpcf7-form-control-wrap");
      const kWrap =
        lastKana.closest && lastKana.closest(".wpcf7-form-control-wrap");
      if (t === lastKana || (tWrap && kWrap && tWrap === kWrap)) return false;

      const rel = lastKana.compareDocumentPosition(t);
      return !!(rel & Node.DOCUMENT_POSITION_FOLLOWING);
    };

    const hasActualValue = (el) => {
      if (!el) return false;

      if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
        if (el.type === "checkbox" || el.type === "radio") return el.checked;
        return el.value.trim() !== "";
      }
      if (el instanceof HTMLSelectElement) {
        return (el.value ?? "").trim() !== "";
      }
      return false;
    };

    const autoTouchRequiredEmptyKana = () => {
      targetNames.forEach((name) => {
        const input = form.querySelector(`input[name="${name}"]`);
        if (!input) return;

        const required = isRequiredField(input);
        const v = input.value.trim();

        if (required && v === "") {
          touched.add(name);
        }
      });
    };

    const schedule = () => {
      if (scheduled) return;
      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;

        if (
          isAfterKanaFields(lastEvent) &&
          hasActualValue(lastEvent && lastEvent.target)
        ) {
          autoTouchRequiredEmptyKana();
        }

        bind(form);
        validateAll(form, false);
      });
    };

    const onAny = (e) => {
      lastEvent = e;
      schedule();
    };

    form.addEventListener("input", onAny, true);
    form.addEventListener("change", onAny, true);
  };

  const showFormMessage = (form, message) => {
    if (!form) return;

    let out = form.querySelector(".wpcf7-response-output");
    if (!out) {
      out = document.createElement("div");
      out.className = "wpcf7-response-output";
      out.setAttribute("aria-hidden", "false");
      form.appendChild(out);
    }

    out.classList.remove("wpcf7-mail-sent-ok");
    out.classList.add("wpcf7-validation-errors");

    out.textContent = message;
    out.style.display = "block";

    form.dataset.kanaCustomOutput = "1";
    setFormInvalidState(form, true);
  };

  const clearFormMessage = (form) => {
    if (!form) return;
    if (form.dataset.kanaCustomOutput !== "1") return;

    const out = form.querySelector(".wpcf7-response-output");
    if (!out) return;

    out.textContent = "";
    out.style.removeProperty("display");
    out.classList.remove("wpcf7-validation-errors");

    delete form.dataset.kanaCustomOutput;
    setFormInvalidState(form, false);
  };

  // ★送信直前：カナが不正なら止めて invalid を付与する
  const bindSubmitBlocker = (form) => {
    if (!form || form.dataset.kanaSubmitBound) return;
    form.dataset.kanaSubmitBound = "1";

    form.addEventListener(
      "submit",
      (e) => {
        bind(form);
        validateAll(form, true);

        const hasKanaInvalid = targetNames.some((name) => {
          const input = form.querySelector(`input[name="${name}"]`);
          if (!input) return false;
          return computeInvalid(input);
        });

        if (hasKanaInvalid) {
          e.preventDefault();
          e.stopImmediatePropagation();

          showFormMessage(form, formErrorText);

          const firstInvalid = targetNames
            .map((name) => form.querySelector(`input[name="${name}"]`))
            .find((input) => input && computeInvalid(input));
          if (firstInvalid) firstInvalid.focus();
        } else {
          clearFormMessage(form);
        }
      },
      true
    );
  };

  bind(document);
  validateAll(document, false);

  document.querySelectorAll(".wpcf7 form").forEach((form) => {
    bindAfterKanaTrigger(form);
    bindSubmitBlocker(form);
  });

  // 送信成功時はエラー状態を消す
  document.addEventListener("wpcf7mailsent", (e) => {
    clearFormMessage(e.target);
    setFormInvalidState(e.target, false);
  });
}
